<template>
  <div class="charing-pile" id="charing-pile">
    <div class="charing-pile-top">
      <el-button class="btn btn-left btn-all" @click="allCharing()"
        >全部</el-button
      >
      <el-button class="btn btn-left btn-disabled" @click="prohibitClick()"
        >禁用列表</el-button
      >
      <el-input
        v-model="chargerName"
        class="btn-left input-left"
        clearable
        placeholder="请输入充电桩名称"
      ></el-input>
      <el-button class="btn btn-left btn-all" @click="searchClick()"
        >查询</el-button
      >
      <el-button
        class="btn btn-right btn-pile"
        @click="addCharger()"
        :disabled="newPrivilege == 1"
        :class="[newPrivilege == 1 ? 'active' : '']"
        >新建充电桩 +</el-button
      >
      <div style="clear: both"></div>
    </div>
    <div class="charing-pile-table">
      <el-table
        :header-cell-style="{
          background: '#f3f3f3',
          color: '#323232',
          height: '50px',
        }"
        :data="yemiandata"
        border
        style="width: 100%"
      >
        <el-table-column prop="charger_id" label="编号" width="">
        </el-table-column>
        <el-table-column prop="charger_name" label="名称" width="">
        </el-table-column>
        <el-table-column
          prop="station_name"
          :show-overflow-tooltip="true"
          label="场站"
        >
        </el-table-column>
        <el-table-column prop="charge_type" label="快慢充" width="65">
          <template slot-scope="scope">
            <span v-if="scope.row.charge_type == 1" class="quick-charge"
              >快充</span
            >
            <span v-else-if="scope.row.charge_type == 2" class="slow-charging"
              >慢充</span
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="serial_no"
          label="序列号"
          :show-overflow-tooltip="true"
          width="100"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.serial_no == 'null'">--</span>
            <span v-else>{{ scope.row.serial_no | defaultValFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="maker_name" label="供应商" width="100">
          <template slot-scope="scope">
            {{ scope.row.maker_name | defaultValFilter }}
          </template>
        </el-table-column>
        <el-table-column prop="model_name" label="类型" width="80">
          <template slot-scope="scope">
            {{scope.row.model_name|defaultValFilter}}KW
            <!-- <span v-if="scope.row.model == 1">7KW</span>
            <span v-else-if="scope.row.model == 2">30KW</span>
            <span v-else-if="scope.row.model == 3">60KW</span>
            <span v-else-if="scope.row.model == 4">40KW</span>
            <span v-else-if="scope.row.model == 5">42KW</span>
            <span v-else-if="scope.row.model == 6">80KW</span>
            <span v-else-if="scope.row.model == 7">84KW</span>
            <span v-else-if="scope.row.model == 8">90KW</span>
            <span v-else-if="scope.row.model == 9">120KW</span>
            <span v-else-if="scope.row.model == 10">240KW</span>
            <span v-else-if="scope.row.model == 11">180KW</span>
             <span v-else>--</span> -->
          </template>
        </el-table-column>
        <el-table-column prop="no_gun" label="枪数" width="60">
        </el-table-column>
        <el-table-column prop="type" label="交直模式" width="110">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 'AC'" class="communication"
              >交流设备</span
            >
            <span v-else-if="scope.row.type == 'DC'" class="direct"
              >直流设备</span
            >
            <span v-else-if="scope.row.type == 'DC/AC'" class="communication"
              >交直流一体设备</span
            >
            <span v-else-if="scope.row.type == 'WIRELESS'" class="direct"
              >无线设备</span
            >
            <span v-else-if="scope.row.type == 'OTHER'" class="direct"
              >其它</span
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" class="enable">启用</span>
            <span v-else-if="scope.row.status == 2" class="enable-prohibit"
              >禁用</span
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="special_use" label="是否公开" width="70">
          <template slot-scope="scope">
            <span v-if="scope.row.special_use == 0">是</span>
            <span v-else-if="scope.row.special_use == 1">否</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="disabled_time"
          label="禁用时间"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">{{
            scope.row.disabled_time | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column
          prop="disabled_reason"
          label="禁用原因"
          :show-overflow-tooltip="true"
          width="80"
        >
          <template slot-scope="scope">{{
            scope.row.disabled_reason | defaultValFilter
          }}</template>
        </el-table-column>
        <el-table-column prop="installed_date" label="安装日期" width="100">
        </el-table-column>

        <el-table-column label="操作" width="270">
          <template slot-scope="scope">
            <el-button
              class="btn edit"
              @click="editCharing(scope.row, 1)"
              :disabled="editPrivilege == 1"
              :class="[editPrivilege == 1 ? 'active' : '']"
              >编辑</el-button
            >
            <el-button
              class="btn delete"
              @click="deleteCharing(scope.row)"
              :disabled="deletePrivilege == 1"
              :class="[deletePrivilege == 1 ? 'active' : '']"
              >删除</el-button
            >
            <el-button
              class="btn rate"
              @click="rateClick(scope.row)"
              :disabled="ratePrivilege == 1"
              :class="[ratePrivilege == 1 ? 'active' : '']"
              >费率</el-button
            >
            <el-button
              class="btn disabled"
              v-if="scope.row.status == 1"
              @click="disableCharger(scope.row)"
              :disabled="prohibitPrivilege == 1"
              :class="[prohibitPrivilege == 1 ? 'active' : '']"
              >禁用</el-button
            >
            <el-button
              class="btn disabled"
              v-else-if="scope.row.status == 2"
              @click="enableClick(scope.row)"
              :disabled="prohibitPrivilege == 1"
              :class="[prohibitPrivilege == 1 ? 'active' : '']"
              >启用</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="prev, pager, next"
        @size-change="handleSizeChange"
        @current-change="currentChange"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <!-- 新建编辑充电桩 -->
    <el-dialog
      :visible.sync="newChargingPileDialog"
      customClass="new-charging-pile-dialog"
      width="934px"
      @close="cancelClick"
      :close-on-click-modal="false"
    >
      <p class="title">{{ chargingPileTitle }}</p>
      <div class="line"></div>
      <div class="charging-pile-content">
        <el-row>
          <el-col :span="12">
            <div class="grid-content bg-purple">
              <div class="content-left">
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>场站：</span>
                  </div>
                  <div class="details-r">
                    <el-select
                      v-model="provincesNameC"
                      clearable
                      :disabled="disabledD == 1"
                      placeholder="请选择省"
                      @change="provincesDChange"
                    >
                      <el-option
                        v-for="item in provincesListC"
                        :key="item.province"
                        :label="item.province"
                        :value="item.province"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="cityNameC"
                      clearable
                      :disabled="disabledD == 1"
                      placeholder="请选择市"
                      @change="cityDChange"
                    >
                      <el-option
                        v-for="item in cityListC"
                        :key="item.city"
                        :label="item.city"
                        :value="item.city"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="stationNameC"
                      clearable
                      :disabled="disabledD == 1"
                      placeholder="请选择场站"
                      @change="stationDChange"
                    >
                      <el-option
                        v-for="item in stationListC"
                        :key="item.station_id"
                        :label="item.station_name"
                        :value="item.station_id"
                      ></el-option>
                    </el-select>
                    <div style="clear: both"></div>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>充电桩编号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="charger_id"
                      clearable
                      :disabled="editNumber == 1"
                      placeholder="唯一，充电桩逻辑地址"
                    ></el-input>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>安装日期：</span>
                  </div>
                  <div class="details-r">
                    <el-date-picker
                      style="width: 100%"
                      v-model="installed_date"
                      type="date"
                      placeholder="选择日期"
                    >
                    </el-date-picker>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>快慢充类型：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="charge_type"
                      clearable
                      placeholder="请选择快慢充类型"
                    >
                      <el-option
                        v-for="item in chargeTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>充电桩型号：</span>
                  </div>
                  <div class="details-r2">
                    <!-- <el-input
                      v-model="model"
                      clearable
                      placeholder="请输入纯数字"
                    ></el-input> -->
                    <el-select
                      v-model="model"
                      clearable
                      placeholder="请选择充电桩型号"
                    >
                      <el-option
                        v-for="item in modelList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>是否公开：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="isPublic"
                      clearable
                      placeholder="请选择是否公开"
                    >
                      <el-option
                        v-for="item in isPublicList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span>组织机构代码：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="manufacturer_sn"
                      maxlength="9"
                      clearable
                      placeholder="请输入设备生产商组织机构代码"
                    ></el-input>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span>设备生产商名称：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="manufacturer_name"
                      maxlength="30"
                      clearable
                      placeholder="请输入设备生产商名称"
                    ></el-input>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>充电设备总功率：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="equipment_power"
                      clearable
                      placeholder="请输入充电设备总功率，单位KW`h"
                    ></el-input>
                  </div>
                </div>
                <div class="fg-line"></div>
                <div class="details">
                  <div class="details-title">
                    <span>充电设备接口名称：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="connector_name[0]"
                      maxlength="30"
                      clearable
                      placeholder="请输入充电设备接口名称"
                    ></el-input>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>设备接口类型：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="connectorType[0]"
                      clearable
                      placeholder="请选择充电设备接口类型"
                    >
                      <el-option
                        v-for="item in connectorTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>额定电压上限：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="rated_voltage_upper_limit[0]"
                      clearable
                      placeholder="请输入额定电压上限，单位V"
                    ></el-input>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>额定电压下限：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="rated_voltage_lower_limit[0]"
                      clearable
                      placeholder="请输入额定电压下限，单位V"
                    ></el-input>
                  </div>
                </div>
                <div class="fg-line" v-if="no_gun == 2"></div>
                <div class="details" v-if="no_gun == 2">
                  <div class="details-title">
                    <span>充电设备接口名称：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="connector_name[1]"
                      maxlength="30"
                      clearable
                      placeholder="请输入充电设备接口名称"
                    ></el-input>
                  </div>
                </div>
                <div class="details" v-if="no_gun == 2">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>设备接口类型：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="connectorType[1]"
                      clearable
                      placeholder="请选择充电设备接口类型"
                    >
                      <el-option
                        v-for="item in connectorTypeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="details" v-if="no_gun == 2">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>额定电压上限：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="rated_voltage_upper_limit[1]"
                      clearable
                      placeholder="请输入额定电压上限，单位V"
                    ></el-input>
                  </div>
                </div>
                <div class="details" v-if="no_gun == 2">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>额定电压下限：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="rated_voltage_lower_limit[1]"
                      clearable
                      placeholder="请输入额定电压下限，单位V"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple-light">
              <div class="content-right">
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>充电桩名称：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="charger_name"
                      clearable
                      placeholder="请输入充电桩名称"
                    ></el-input>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>桩供应商：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      style="width: 49%"
                      v-model="maker"
                      clearable
                      @change="chooseTemplate"
                      placeholder="请选择桩供应商"
                    >
                      <el-option
                        v-for="item in makerList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.supplier_code"
                      ></el-option>
                    </el-select>

                    <el-select
                      style="width: 49%"
                      @change="choosePT"
                      v-model="pliaTemplate"
                      clearable
                      placeholder="请选择桩模板"
                    >
                      <el-option
                        v-for="item in pliaTemplateList"
                        :key="item.id"
                        :label="item.template_name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>充电设备用途：</span>
                  </div>
                  <div class="details-r">
                    <el-select
                      style="width: 100%"
                      v-model="equipment_application"
                      clearable
                      placeholder="请选择充电设备用途"
                    >
                      <el-option
                        v-for="item in equipment_applicationList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>交直流类型：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="type"
                      clearable
                      placeholder="请选择交直流类型"
                    >
                      <el-option
                        v-for="item in typeList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>单双枪类型：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="no_gun"
                      clearable
                      placeholder="请选择单双枪类型"
                    >
                      <el-option
                        v-for="item in noGunList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span>出厂序列号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="serial_no"
                      clearable
                      placeholder="请输入充出厂序列号"
                    ></el-input>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span>设备型号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="equipment_model"
                      maxlength="20"
                      clearable
                      placeholder="请输入设备型号"
                    ></el-input>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>充电设备经度：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="longitude"
                      clearable
                      placeholder="请输入充电设备经度"
                    ></el-input>
                  </div>
                </div>
                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>充电设备纬度：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="latitude"
                      clearable
                      placeholder="请输入充电设备纬度"
                    ></el-input>
                  </div>
                </div>

                <div class="fg-line"></div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>国家标准：</span>
                  </div>
                  <div class="details-r2">
                    <el-select
                      v-model="national_standard"
                      clearable
                      placeholder="请选择国家标准"
                    >
                      <el-option
                        v-for="item in national_standardList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>额定电流：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="rated_current[0]"
                      clearable
                      placeholder="请输入额定电流，单位A"
                    ></el-input>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>额定功率：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="rated_power[0]"
                      clearable
                      placeholder="请输入额定功率，单位KW`h"
                    ></el-input>
                  </div>
                </div>

                <div class="details">
                  <div class="details-title">
                    <span>车位号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="park_no[0]"
                      clearable
                      placeholder="请输入车位号"
                    ></el-input>
                  </div>
                </div>

                <div class="fg-line" v-if="no_gun == 2"></div>

                <div class="details" v-if="no_gun == 2">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>额定电流：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="rated_current[1]"
                      clearable
                      placeholder="请输入额定电流，单位A"
                    ></el-input>
                  </div>
                </div>
                <div class="details" v-if="no_gun == 2">
                  <div class="details-title">
                    <span class="star">*</span>
                    <span>额定功率：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="rated_power[1]"
                      clearable
                      placeholder="请输入额定功率，单位KW`h"
                    ></el-input>
                  </div>
                </div>
                <div class="details" v-if="no_gun == 2">
                  <div class="details-title">
                    <span>车位号：</span>
                  </div>
                  <div class="details-r">
                    <el-input
                      v-model="park_no[1]"
                      clearable
                      placeholder="请输入车位号"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="button">
          <el-button class="button-cancel" @click="cancelClick()"
            >取消</el-button
          >
          <el-button
            class="button-confirm"
            v-if="chargingPileTitle == '新建充电桩'"
            @click="confirmClick()"
            >确认</el-button
          >
          <el-button
            class="button-confirm"
            v-else-if="chargingPileTitle == '编辑充电桩'"
            @click="confirmClick2()"
            >确认</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 禁用 -->
    <el-dialog
      :visible.sync="prohibitDialog"
      customClass="prohibit-dialog"
      width="934px"
      @close="prohibitCancelClick"
    >
      <p class="title">禁用充电桩</p>
      <div class="line"></div>
      <div class="prohibit-reason">
        <div class="text"><span class="star">*</span>禁用理由：</div>
        <div class="reason-box">
          <el-input
            type="textarea"
            clearable
            :autosize="{ minRows: 4 }"
            placeholder="请输入禁用理由"
            v-model="prohibitReason"
          >
          </el-input>
        </div>
      </div>
      <div class="pro-button">
        <el-button class="pro-btn pro-cancel" @click="prohibitCancelClick()"
          >取消</el-button
        >
        <el-button class="pro-btn pro-confirm" @click="prohibitConfirmClick()"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 充电桩当前费率 -->
    <el-dialog
      :visible.sync="royaltyRateDialog"
      customClass="royalty-rate-dialog"
      width="934px"
    >
      <p class="title">充电桩当前费率</p>
      <div class="line"></div>
      <div class="royalty-rate-content">
        <div class="rate-top">
          <div class="rate-t-l">
            <span>充电桩：</span>
            <span>{{ rateList.charger_name | defaultValFilter }}</span>
          </div>
          <div class="rate-t-r">
            <span>运营商：</span>
            <span>{{ rateList.enterprise_name | defaultValFilter }}</span>
          </div>
        </div>
        <div class="rate-center" v-if="rateList.parking_rates == false">
          <div class="rate-c-title">
            <span>费率/服务费（单位：元）</span>
          </div>
          <div class="rate-c-content">
            <div class="rate-details">
              <span class="rate-details-l">费率1</span>
              <span class="rate-details-r">{{
                rateList.rate1 | defaultValFilter
              }}</span>
              <div style="clear: both"></div>
            </div>
            <div class="rate-details">
              <span class="rate-details-l">费率2</span>
              <span class="rate-details-r">{{
                rateList.rate2 | defaultValFilter
              }}</span>
              <div style="clear: both"></div>
            </div>
            <div class="rate-details">
              <span class="rate-details-l">费率3</span>
              <span class="rate-details-r">{{
                rateList.rate3 | defaultValFilter
              }}</span>
              <div style="clear: both"></div>
            </div>
          </div>
          <div class="rate-c-content">
            <div class="rate-details">
              <span class="rate-details-l">费率4</span>
              <span class="rate-details-r">{{
                rateList.rate4 | defaultValFilter
              }}</span>
              <div style="clear: both"></div>
            </div>
            <div class="rate-details">
              <span class="rate-details-l">服务费</span>
              <span class="rate-details-r">{{
                rateList.serv_fee | defaultValFilter
              }}</span>
              <div style="clear: both"></div>
            </div>
            <div class="rate-details">
              <span class="rate-details-l"></span>
              <span class="rate-details-r"></span>
              <div style="clear: both"></div>
            </div>
          </div>
        </div>
        <div class="rate-bottom">
          <div class="rate-b-title" v-if="rateList.parking_rates == false">
            <span>费率时段模板</span>
          </div>
          <div class="rate-b-content" v-if="rateList.parking_rates == false">
            <div
              class="content-l"
              v-for="(item, index) in rateList.timeslot"
              :key="index"
            >
              <div class="content-l-l">
                {{ item.timeslot | defaultValFilter }}
              </div>
              <div class="content-l-c">
                {{ item.start_time | defaultValFilter }}点
              </div>
              <div class="content-l-c">
                {{ item.end_time | defaultValFilter }}点
              </div>
              <div class="content-l-r">{{ item.rate | defaultValFilter }}</div>
              <div style="clear: both"></div>
            </div>
            <div style="clear: both"></div>
          </div>
          <div class="dialog-bottom clearfix" v-else>
            <div class="dialog-bottom-title">费率时段模板</div>
            <div class="bottom-line"></div>
            <div
              class="dialog-bottom-select clearfix"
              v-for="(item, index) in rateList.parking_rates"
              :key="index"
            >
              <span class="time1">时段{{ index + 1 }}</span>
              <span class="box"
                >{{ item.StartTime | defaultValFilter }} ~
                {{ item.EndTime | defaultValFilter }}</span
              >
              <span class="box">电费：{{ item.Price | defaultValFilter }}</span>
              <span class="box"
                >服务费：{{ item.ServiePrice | defaultValFilter }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import { parseDateFilter } from "@/filters";
export default {
  props: ["provincesName", "cityName", "stationId"],
  data() {
    return {
      makerList: [],
      pliaTemplateList: [],
      pliaTemplate: "",
      value: "",
      newChargingPileDialog: false,
      prohibitDialog: false,
      royaltyRateDialog: false,
      tableData: [],
      // 页面需要展现的数据
      yemiandata: [],
      // 页面展现条数
      datanum: 10,
      // 开始页数
      startnum: 0,
      // 结束页数
      endnum: 1,
      // 一共多少页
      totalNum: 0,
      chargingPileTitle: "",
      chargerName: "",
      provincesNameC: "",
      provincesListC: [],
      cityNameC: "",
      cityListC: [],
      stationNameC: "",
      stationNameIdC: "",
      stationListC: "",
      charger_id: "",
      charger_name: "",
      type: "",
      charge_type: "",
      serial_no: "",
      no_gun: "",
      installed_date: "",
      maker: "",
      model: "",
      chargeTypeList: [
        {
          value: "1",
          label: "快充",
        },
        {
          value: "2",
          label: "慢充",
        },
      ],
      typeList: [
        {
          value: "AC",
          label: "交流设备",
        },
        {
          value: "DC",
          label: "直流设备",
        },
        {
          value: "DC/AC",
          label: "交直流一体设备",
        },
        {
          value: "WIRELESS",
          label: "无线设备",
        },
        {
          value: "OTHER",
          label: "其他",
        },
      ],
      noGunList: [
        {
          value: "1",
          label: "单枪",
        },
        {
          value: "2",
          label: "双枪",
        },
      ],
      modelList: [
        // {
        //   value: "1",
        //   label: "7KW",
        // },
        // {
        //   value: "2",
        //   label: "30KW",
        // },
        // {
        //   value: "3",
        //   label: "60KW",
        // },
        // {
        //   value: "4",
        //   label: "40KW",
        // },
        // {
        //   value: "5",
        //   label: "42KW",
        // },
        // {
        //   value: "6",
        //   label: "80KW",
        // },
        // {
        //   value: "7",
        //   label: "84KW",
        // },
        // {
        //   value: "8",
        //   label: "90KW",
        // },
        // {
        //   value: "9",
        //   label: "120KW",
        // },
        // {
        //   value: "11",
        //   label: "180kw",
        // },
        // {
        //   value: "10",
        //   label: "240KW",
        // },
      ],
      disabledD: 0,
      prohibitReason: "",
      prohibitChargerId: "",
      rateList: {},
      iW2: "",
      editNumber: 0,
      newPrivilege: 1, //新建
      editPrivilege: 1, //编辑
      deletePrivilege: 1, //删除
      ratePrivilege: 1, //费率
      prohibitPrivilege: 1, //禁用
      isPublic: "0", //是否公开
      isPublicList: [
        {
          value: "0",
          label: "是",
        },
        {
          value: "1",
          label: "否",
        },
      ],
      // 互联互通
      longitude: "", //场站经度
      latitude: "", //场站纬度
      // equipment_sn: "", //设备唯一编号
      manufacturer_sn: "", //设备生产商组织机构代码
      manufacturer_name: "", //设备生产商名称
      equipment_model: "", //设备型号
      equipment_power: "", //充电设备总功率
      national_standard: "", //国家标准
      national_standardList: [
        {
          value: "2011",
          label: "2011",
        },
        {
          value: "2015",
          label: "2015",
        },
      ],
      equipment_application:"",
      equipment_applicationList:[
        {
          value:"1",
          label:"公用"
        },
        {
          value:"2",
          label:"专用"
        },
        {
          value:"3",
          label:"个人分时共享"
        },
        {
          value:"4",
          label:"限制类公用"
        },
        {
          value:"9",
          label:"其他"
        },
      ],
      connector_name: [], //充电设备接口名称
      rated_voltage_upper_limit: [], //额定电压上限
      rated_voltage_lower_limit: [], //额定电压下限
      rated_current: [], //额定电流
      park_no: [], //车位号
      connectorType: [], //充电设备接口类型
      connectorTypeList: [
        {
          value: "1",
          label: "家用插座（模式2)",
        },
        {
          value: "2",
          label: "交流接口插座（模式3, 连接方式B)",
        },
        {
          value: "3",
          label: "交流接口插头（带枪线，模式3, 连接方式C)",
        },
        {
          value: "4",
          label: "直流接口枪头（带枪线，模式4）",
        },
        {
          value: "5",
          label: "无线充电座",
        },
        {
          value: "6",
          label: "其他",
        },
      ],
      rated_power: [], //额定功率
    };
  },
  mounted() {
    this.$nextTick(function () {
      let w1 = document.getElementById("charing-pile");
      this.iW2 = w1.clientWidth || w1.offsetWidth;
      this.iW2 = this.iW2 * 0.97;

      let role = [];
      role = this.$store.state.role;
      for (let i in role) {
        if (role[i].view_name == "场站管理") {
          for (let j in role[i].chlid) {
            if (role[i].chlid[j].view_name == "设备管理") {
              for (let m in role[i].chlid[j].method) {
                if (role[i].chlid[j].method[m].method_name == "新建充电桩") {
                  this.newPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "编辑充电桩"
                ) {
                  this.editPrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "删除充电桩"
                ) {
                  this.deletePrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "查看充电桩费率"
                ) {
                  this.ratePrivilege = 0;
                } else if (
                  role[i].chlid[j].method[m].method_name == "禁用/启用充电桩"
                ) {
                  this.prohibitPrivilege = 0;
                }
              }
            }
          }
        }
      }
      this.getpowerList()
      this.getDataList(this.provincesName, this.cityName, this.stationId);
      this.getmerchantsList();
    });
  },
  watch: {
    provincesName: function (newVal, oldVal) {
      // debugger
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getDataList(this.provincesName, this.cityName, this.stationId);
    },
    cityName: function (newVal, oldVal) {
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getDataList(this.provincesName, this.cityName, this.stationId);
    },
    stationId: function (newVal, oldVal) {
      this.totalNum = 0;
      this.startnum = 0;
      this.endnum = 1;
      this.getDataList(this.provincesName, this.cityName, this.stationId);
    },
  },
  methods: {
    getpowerList(){
      let params={
        uid:localStorage.getItem("uid"),
        token:localStorage.getItem("token"),
        action:"getChargerPowerLists"
      }
      this.$api({
        method:"POST",
        url:"/api.php/deviceManage/Index",
        data:params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then(res=>{
        res.data.list.map(item=>{
          this.modelList.push({value:item.id,label:item.powers+"KW"})
        })
      })
    },
    handleSizeChange(data) {
      // debugger
    },
    currentChange(data) {
      this.endnum = data;
      this.startnum = data - 1;
      // this.yemiandata=this.tableData.slice(this.startnum*this.datanum,this.endnum*this.datanum);
      if (this.totalNum > 10) {
        this.yemiandata = this.tableData.slice(
          this.startnum * this.datanum,
          this.endnum * this.datanum
        );
      } else {
        this.yemiandata = this.tableData;
      }
    },
    searchClick() {
      this.getDataList(this.provincesName, this.cityName, this.stationId);
    },
    getmerchantsList() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "listsSupplier",
      };
      this.$api({
        method: "post",
        url: "/api.php/supplierManage/Index",
        data: params,

        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((res) => {
        if (res.data.code == 1) {
          this.makerList = res.data.list;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getDataList(provincesName, cityName, stationId) {
      if (provincesName == undefined) {
        provincesName = "";
      }
      if (cityName == undefined) {
        cityName = "";
      }
      if (stationId == undefined) {
        stationId = "";
      }

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getChargerList",
        province: provincesName,
        city: cityName,
        station_id: stationId,
        charger_name: this.chargerName,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            // debugger
            this.tableData = su.data.list;
            this.totalNum = this.tableData.length;
            if (this.totalNum > 10) {
              // debugger
              this.yemiandata = this.tableData.slice(
                this.startnum * this.datanum,
                this.endnum * this.datanum
              );
            } else {
              this.yemiandata = this.tableData;
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    //获取桩模板类型
    getcharingPie(val){
      this.pliaTemplateList=[]
      let params = {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action: "supplierChargeTempLists",
          supplier_code: val,
        };

        this.$api({
          method: "post",
          url: "/api.php/deviceTemplate/Index",
          data: params,
          transformRequest: [
            (data) => {
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              return ret;
            },
          ],
        }).then((su) => {
          if (su.data.code == 1) {
            this.pliaTemplateList = su.data.data.lists;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
            this.$message.warning(su.data.message);
          } else {
            this.$message.warning(su.data.message);
          }
        });
    },
    chooseTemplate(val) {
      if (val != "") {
        this.getcharingPie(val)
      } else {
      }
    },
    addCharger() {
      this.pliaTemplateList=[]
      this.chargingPileTitle = "新建充电桩";
      this.newChargingPileDialog = true;
      this.editNumber = 0;
      this.getCharProvinces();
      this.disabledD = 0;
      this.pliaTemplate = "";
    },
    getCharProvinces() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_provinces",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.provincesListC = su.data.list;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    choosePT(val) {
      this.stationNameIdC = "";
      // this.charger_id = "";
      // this.charger_name = "";
      this.type = "";
      this.charge_type = "";
      // this.serial_no = "";
      this.no_gun = "";
      // this.installed_date = "";
      this.maker = "";
      this.model = "";
      // this.provincesNameC = "";
      // this.cityNameC = "";
      // this.stationNameC = "";
      this.editNumber = 0;
      this.isPublic = "0";

      this.manufacturer_sn = "";
      this.manufacturer_name = "";
      this.equipment_model = "";
      this.equipment_power = "";
      this.national_standard = "";
      // this.longitude = "";
      // this.latitude = "";
      // this.equipment_sn = "";

      this.connector_name = [];
      this.connectorType = [];
      this.rated_voltage_upper_limit = [];
      this.rated_voltage_lower_limit = [];
      this.rated_current = [];
      this.park_no = [];
      this.rated_power = [];

      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "detailChargeTemp",
        id: val,
      };
      this.$api({
        method: "post",
        url: "/api.php/deviceTemplate/Index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      }).then((su) => {
        if (su.data.code == 1) {
          // this.stationNameC = su.data.list.station_id;
          this.charge_type = su.data.list.charge_type==""?this.charge_type:su.data.list.charge_type;
          // this.charger_id = su.data.list.charger_id;
          // this.charger_name = su.data.list.charger_name;
          // this.installed_date = su.data.list.installed_date;
          this.maker = su.data.list.maker==""?this.maker:su.data.list.maker;
          this.model = su.data.list.model==""?this.model:su.data.list.model;
          this.no_gun = su.data.list.no_gun;
          // this.serial_no = su.data.list.serial_no;
          this.type = su.data.list.type==""?this.type:su.data.list.type;
          this.isPublic = su.data.list.special_use==""?this.isPublic:su.data.list.special_use;

          this.manufacturer_sn = su.data.list.manufacturer_sn==""?this.manufacturer_sn:su.data.list.manufacturer_sn;
          // this.equipment_sn = su.data.list.equipment_sn;
          this.manufacturer_name = su.data.list.manufacturer_name==""?this.manufacturer_name:su.data.list.manufacturer_name;
          this.equipment_model = su.data.list.equipment_model==""?this.equipment_model:su.data.list.equipment_model;
          this.equipment_power = su.data.list.equipment_power==""?this.equipment_power:su.data.list.equipment_power;
          // this.longitude = su.data.list.equipment_longitude;
          // this.latitude = su.data.list.equipment_latitude;

          if (su.data.list.gun.length > 0) {
            this.connectorType[0] = su.data.list.gun[0].connector_type==""?this.connectorType[0]:su.data.list.gun[0].connector_type;
            this.connector_name[0] = su.data.list.gun[0].connector_name==""?this.connector_name[0]:su.data.list.gun[0].connector_name;
            this.rated_voltage_upper_limit[0] =
              su.data.list.gun[0].rated_voltage_upper_limit==""?this.rated_voltage_upper_limit[0]:su.data.list.gun[0].rated_voltage_upper_limit;
            this.rated_voltage_lower_limit[0] =
              su.data.list.gun[0].rated_voltage_lower_limit==""?this.rated_voltage_lower_limit[0]:su.data.list.gun[0].rated_voltage_lower_limit;
            this.rated_current[0] = su.data.list.gun[0].rated_current==""?this.rated_current[0]:su.data.list.gun[0].rated_current;
            this.park_no[0] = su.data.list.gun[0].park_no==""?this.park_no[0]:su.data.list.gun[0].park_no;
            this.rated_power[0] = su.data.list.gun[0].rated_power==""?this.rated_power[0]:su.data.list.gun[0].rated_power;
            this.national_standard = su.data.list.gun[0].national_standard==""?this.national_standard:su.data.list.gun[0].national_standard;
            if (su.data.list.gun.length > 1) {
              this.connectorType[1] = su.data.list.gun[1].connector_type==""?this.connectorType[1]:su.data.list.gun[1].connector_type;
              this.connector_name[1] = su.data.list.gun[1].connector_name==""?this.connector_name[1]:su.data.list.gun[1].connector_name;
              this.rated_voltage_upper_limit[1] =
                su.data.list.gun[1].rated_voltage_upper_limit==""?this.rated_voltage_upper_limit[1]:su.data.list.gun[1].rated_voltage_upper_limit;
              this.rated_voltage_lower_limit[1] =
                su.data.list.gun[1].rated_voltage_lower_limit==""?this.rated_voltage_lower_limit[1]:su.data.list.gun[1].rated_voltage_lower_limit;
              this.rated_current[1] = su.data.list.gun[1].rated_current==""?this.rated_current[1]:su.data.list.gun[1].rated_current;
              this.park_no[1] = su.data.list.gun[1].park_no==""?this.park_no[1]:su.data.list.gun[1].park_no;
              this.rated_power[1] = su.data.list.gun[1].rated_power==""?this.rated_power[1]:su.data.list.gun[1].rated_power;
            }
          }
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    provincesDChange(province) {
      this.cityNameC = "";
      this.cityListC = [];
      this.stationNameC = "";
      this.stationListC = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        province: province,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_citys",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.cityListC = su.data.list;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    cityDChange(city) {
      this.stationListC = [];
      this.stationNameC = "";
      this.stationNameIdC = "";
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        city: city,
      };
      this.$api({
        method: "post",
        url: "/api.php/Currency/get_stations",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.stationListC = su.data.list;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    stationDChange(id) {
      this.stationNameIdC = id;
      this.getStationLatLong(id);
    },
    getStationLatLong(id) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getStationLatLong",
        station_id: id,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.longitude = su.data.list.longitude;
            this.latitude = su.data.list.latitude;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
            this.$message.warning(su.data.message);
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    cancelClick() {
      this.pliaTemplateList=[]
      this.newChargingPileDialog = false;
      this.stationNameIdC = "";
      this.equipment_application=""
      this.charger_id = "";
      this.charger_name = "";
      this.type = "";
      this.charge_type = "";
      this.serial_no = "";
      this.no_gun = "";
      this.installed_date = "";
      this.maker = "";
      this.model = "";
      this.provincesNameC = "";
      this.cityNameC = "";
      this.stationNameC = "";
      this.editNumber = 0;
      this.isPublic = "0";

      this.manufacturer_sn = "";
      this.manufacturer_name = "";
      this.equipment_model = "";
      this.equipment_power = "";
      this.national_standard = "";
      this.longitude = "";
      this.latitude = "";
      this.equipment_sn = "";

      this.connector_name = [];
      this.connectorType = [];
      this.rated_voltage_upper_limit = [];
      this.rated_voltage_lower_limit = [];
      this.rated_current = [];
      this.park_no = [];
      this.rated_power = [];
    },
    confirmClick() {
      var longrg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;
      var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
      var regs = /^\d{1,}$/;
      var zs = /^[0-9]*$/;
      if (isEmpty(this.stationNameC)) {
        this.$message.warning("请选择场站！");
        return;
      } else if (isEmpty(this.charger_id)) {
        this.$message.warning("请输入充电桩编号！");
        return;
      } else if (isEmpty(this.installed_date)) {
        this.$message.warning("请输入安装日期！");
        return;
      } else if (isEmpty(this.charge_type)) {
        this.$message.warning("请选择快慢充类型！");
        return;
      } else if (isEmpty(this.model)) {
        this.$message.warning("请选择充电桩型号！");
        return;
      } else if (isEmpty(this.charger_name)) {
        this.$message.warning("请输入充电桩名称！");
        return;
      } else if (isEmpty(this.maker)) {
        this.$message.warning("请选择桩供应商！");
        return;
      } else if (isEmpty(this.type)) {
        this.$message.warning("请选择交直流类型！");
        return;
      } else if (isEmpty(this.no_gun)) {
        this.$message.warning("请选择单双枪类型！");
        return;
      } else if (isEmpty(this.longitude)) {
        this.$message.warning("请输入充电设备经度！");
        return;
      } else if (!longrg.test(this.longitude)) {
        this.$message.warning("经度整数部分为0-180,小数部分为0到6位!");
        return;
      } else if (isEmpty(this.latitude)) {
        this.$message.warning("请输入充电设备纬度！");
        return;
      } else if (!latreg.test(this.latitude)) {
        this.$message.warning("纬度整数部分为0-180,小数部分为0到6位!");
        return;
      } else if (isEmpty(this.national_standard)) {
        this.$message.warning("请选择国家标准！");
        return;
      } else if (isEmpty(this.equipment_power)) {
        this.$message.warning("请输入充电设备总功率！");
        return;
      }else if(isEmpty(this.equipment_application)){
        this.$message.warning("请选择设备充电用途！");
        return;
      }

      if (this.no_gun == 1) {
        if (isEmpty(this.connectorType[0])) {
          this.$message.warning("请选择设备接口类型！");
          return;
        } else if (isEmpty(this.rated_voltage_upper_limit[0])) {
          this.$message.warning("请输入额定电压上限！");
          return;
        } else if (!zs.test(this.rated_voltage_upper_limit[0])) {
          this.$message.warning("额定电压上限只能是整数！");
          return;
        } else if (isEmpty(this.rated_voltage_lower_limit[0])) {
          this.$message.warning("请输入额定电压下限！");
          return;
        } else if (!zs.test(this.rated_voltage_lower_limit[0])) {
          this.$message.warning("额定电压下限只能是整数！");
          return;
        } else if (isEmpty(this.rated_current)) {
          this.$message.warning("请输入额定电流！");
          return;
        } else if (!zs.test(this.rated_current[0])) {
          this.$message.warning("额定电流只能是整数！");
          return;
        } else if (isEmpty(this.rated_power)) {
          this.$message.warning("请输入额定功率！");
          return;
        }
        this.rated_power[0] = Number(this.rated_power[0]).toFixed(1);
      } else if (this.no_gun == 2) {
        if (isEmpty(this.connectorType[1])) {
          this.$message.warning("请选择设备接口类型！");
          return;
        } else if (isEmpty(this.rated_voltage_upper_limit[0])) {
          this.$message.warning("请输入额定电压上限！");
          return;
        } else if (!zs.test(this.rated_voltage_upper_limit[0])) {
          this.$message.warning("额定电压上限只能是整数！");
          return;
        } else if (isEmpty(this.rated_voltage_lower_limit[0])) {
          this.$message.warning("请输入额定电压下限！");
          return;
        } else if (!zs.test(this.rated_voltage_lower_limit[0])) {
          this.$message.warning("额定电压下限只能是整数！");
          return;
        } else if (isEmpty(this.rated_current[0])) {
          this.$message.warning("请输入额定电流！");
          return;
        } else if (!zs.test(this.rated_current[0])) {
          this.$message.warning("额定电流只能是整数！");
          return;
        } else if (isEmpty(this.rated_power[0])) {
          this.$message.warning("请输入额定功率！");
          return;
        } else if (isEmpty(this.rated_voltage_upper_limit[1])) {
          this.$message.warning("请输入额定电压上限！");
          return;
        } else if (!zs.test(this.rated_voltage_upper_limit[1])) {
          this.$message.warning("额定电压上限只能是整数！");
          return;
        } else if (isEmpty(this.rated_voltage_lower_limit[1])) {
          this.$message.warning("请输入额定电压下限！");
          return;
        } else if (!zs.test(this.rated_voltage_lower_limit[1])) {
          this.$message.warning("额定电压下限只能是整数！");
          return;
        } else if (isEmpty(this.rated_current[1])) {
          this.$message.warning("请输入额定电流！");
          return;
        } else if (!zs.test(this.rated_current[1])) {
          this.$message.warning("额定电流只能是整数！");
          return;
        } else if (isEmpty(this.rated_power[1])) {
          this.$message.warning("请输入额定功率！");
          return;
        } else if (!regs.test(this.model)) {
          this.$message.warning("请输入正确格式的充电桩型号！");
          return;
        }

        this.rated_power[0] = Number(this.rated_power[0]).toFixed(1);
        this.rated_power[1] = Number(this.rated_power[1]).toFixed(1);
      }

      let params = {
        // uid: localStorage.getItem("uid"),
        // token: localStorage.getItem("token"),
        // action:"addCharger",
        // station_id:this.stationNameIdC,
        // charger_id:this.charger_id,
        // charger_name:this.charger_name,
        // type:this.type,
        // charge_type:this.charge_type,
        // serial_no:this.serial_no,
        // no_gun:this.no_gun,
        // installed_date:this.installed_date,
        // maker:this.maker,
        // model:this.model,
        // special_use:this.isPublic,
        // manufacturer_sn:this.manufacturer_sn,
        // manufacturer_name:this.manufacturer_name,
        // equipment_model:this.equipment_model,
        // equipment_power:this.equipment_power,
        // longitude:this.longitude,
        // latitude:this.latitude,
        // equipment_sn:this.equipment_sn,
        // national_standard:this.national_standard,
        // connector_name:this.connector_name,
        // connector_type:this.connectorType,
        // rated_voltage_upper_limit:this.rated_voltage_upper_limit,
        // rated_voltage_lower_limit:this.rated_voltage_lower_limit,
        // rated_current:this.rated_current,
        // park_no:this.park_no,
        // rated_power:this.rated_power,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = Qs.stringify(data);
            return data;
          },
        ],
        params: {},
        data: {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action: "addCharger",
          station_id: this.stationNameC,
          charger_id: this.charger_id,
          charger_name: this.charger_name,
          type: this.type,
          charge_type: this.charge_type,
          serial_no: this.serial_no,
          no_gun: this.no_gun,
          installed_date: parseDateFilter(this.installed_date, "yyyy-MM-dd"),
          maker: this.maker,
          model: this.model,
          special_use: this.isPublic,
          equipment_application:this.equipment_application,

          manufacturer_sn: this.manufacturer_sn,
          manufacturer_name: this.manufacturer_name,
          equipment_model: this.equipment_model,
          equipment_power: Number(this.equipment_power).toFixed(1),
          longitude: this.longitude,
          latitude: this.latitude,
          // equipment_sn: this.equipment_sn,
          national_standard: this.national_standard,

          connector_name: this.connector_name,
          connector_type: this.connectorType,
          rated_voltage_upper_limit: this.rated_voltage_upper_limit,
          rated_voltage_lower_limit: this.rated_voltage_lower_limit,
          rated_current: this.rated_current,
          park_no: this.park_no,
          rated_power: this.rated_power,
        },
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.pliaTemplateList=[]
            this.newChargingPileDialog = false;
            this.$message.success("新建成功");
            this.editNumber = 0;
            this.totalNum = 0;
            this.startnum = 0;
            this.endnum = 1;
            this.getDataList();
            this.$emit("listenToChildEvent", "空");
            // this.provincesName = "";
            // this.cityName = '';
            // this.stationId = '';
            // this.$emit("listenToChildEvent",this.cityName);
            // this.$emit("listenToChildEvent",this.stationId);
            this.stationNameIdC = "";
            this.charger_id = "";
            this.charger_name = "";
            this.type = "";
            this.charge_type = "";
            this.serial_no = "";
            this.no_gun = "";
            this.installed_date = "";
            this.maker = "";
            this.model = "";
            this.provincesNameC = "";
            this.cityNameC = "";
            this.stationNameC = "";
            this.isPublic = "0";
            this.equipment_application=""

            this.manufacturer_sn = "";
            this.manufacturer_name = "";
            this.equipment_model = "";
            this.equipment_power = "";
            this.national_standard = [];
            this.longitude = "";
            this.latitude = "";
            // this.equipment_sn = "";

            this.connector_name = [];
            this.connectorType = [];
            this.rated_voltage_upper_limit = [];
            this.rated_voltage_lower_limit = [];
            this.rated_current = [];
            this.park_no = [];
            this.rated_power = [];
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    confirmClick2() {
      var longrg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,6})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,6}|180)$/;
      var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;
      var zs = /^[0-9]*$/;

      if (isEmpty(this.installed_date)) {
        this.$message.warning("请输入安装日期！");
        return;
      } else if (isEmpty(this.charge_type)) {
        this.$message.warning("请选择快慢充类型！");
        return;
      } else if (isEmpty(this.model)) {
        this.$message.warning("请选择充电桩型号！");
        return;
      } else if (isEmpty(this.charger_name)) {
        this.$message.warning("请输入充电桩名称！");
        return;
      } else if (isEmpty(this.maker)) {
        this.$message.warning("请选择桩供应商！");
        return;
      } else if (isEmpty(this.type)) {
        this.$message.warning("请选择交直流类型！");
        return;
      } else if (isEmpty(this.no_gun)) {
        this.$message.warning("请选择单双枪类型！");
        return;
      }else if (isEmpty(this.longitude)) {
        this.$message.warning("请输入充电设备经度！");
        return;
      } else if (!longrg.test(this.longitude)) {
        this.$message.warning("经度整数部分为0-180,小数部分为0到6位!");
        return;
      } else if (isEmpty(this.latitude)) {
        this.$message.warning("请输入充电设备纬度！");
        return;
      } else if (!latreg.test(this.latitude)) {
        this.$message.warning("纬度整数部分为0-180,小数部分为0到6位!");
        return;
      } else if (isEmpty(this.national_standard)) {
        this.$message.warning("请选择国家标准！");
        return;
      } else if (isEmpty(this.equipment_power)) {
        this.$message.warning("请输入充电设备总功率！");
        return;
      }

      if (this.no_gun == 1) {
        if (isEmpty(this.connectorType[0])) {
          this.$message.warning("请选择设备接口类型！");
          return;
        } else if (isEmpty(this.rated_voltage_upper_limit[0])) {
          this.$message.warning("请输入额定电压上限！");
          return;
        } else if (!zs.test(this.rated_voltage_upper_limit[0])) {
          this.$message.warning("额定电压上限只能是整数！");
          return;
        } else if (isEmpty(this.rated_voltage_lower_limit[0])) {
          this.$message.warning("请输入额定电压下限！");
          return;
        } else if (!zs.test(this.rated_voltage_lower_limit[0])) {
          this.$message.warning("额定电压下限只能是整数！");
          return;
        } else if (isEmpty(this.rated_current)) {
          this.$message.warning("请输入额定电流！");
          return;
        } else if (!zs.test(this.rated_current[0])) {
          this.$message.warning("额定电流只能是整数！");
          return;
        } else if (isEmpty(this.rated_power)) {
          this.$message.warning("请输入额定功率！");
          return;
        }
      } else if (this.no_gun == 2) {
        if (isEmpty(this.connectorType[1])) {
          this.$message.warning("请选择设备接口类型！");
          return;
        } else if (isEmpty(this.rated_voltage_upper_limit[0])) {
          this.$message.warning("请输入额定电压上限！");
          return;
        } else if (!zs.test(this.rated_voltage_upper_limit[0])) {
          this.$message.warning("额定电压上限只能是整数！");
          return;
        } else if (isEmpty(this.rated_voltage_lower_limit[0])) {
          this.$message.warning("请输入额定电压下限！");
          return;
        } else if (!zs.test(this.rated_voltage_lower_limit[0])) {
          this.$message.warning("额定电压下限只能是整数！");
          return;
        } else if (isEmpty(this.rated_current[0])) {
          this.$message.warning("请输入额定电流！");
          return;
        } else if (!zs.test(this.rated_current[0])) {
          this.$message.warning("额定电流只能是整数！");
          return;
        } else if (isEmpty(this.rated_power[0])) {
          this.$message.warning("请输入额定功率！");
          return;
        } else if (isEmpty(this.rated_voltage_upper_limit[1])) {
          this.$message.warning("请输入额定电压上限！");
          return;
        } else if (!zs.test(this.rated_voltage_upper_limit[1])) {
          this.$message.warning("额定电压上限只能是整数！");
          return;
        } else if (isEmpty(this.rated_voltage_lower_limit[1])) {
          this.$message.warning("请输入额定电压下限！");
          return;
        } else if (!zs.test(this.rated_voltage_lower_limit[1])) {
          this.$message.warning("额定电压下限只能是整数！");
          return;
        } else if (isEmpty(this.rated_current[1])) {
          this.$message.warning("请输入额定电流！");
          return;
        } else if (!zs.test(this.rated_current[1])) {
          this.$message.warning("额定电流只能是整数！");
          return;
        } else if (isEmpty(this.rated_power[1])) {
          this.$message.warning("请输入额定功率！");
          return;
        }
      }

      let params = {
        // uid: localStorage.getItem("uid"),
        // token: localStorage.getItem("token"),
        // action:"editCharger",
        // charger_id:this.charger_id,
        // charger_name:this.charger_name,
        // type:this.type,
        // charge_type:this.charge_type,
        // serial_no:this.serial_no,
        // no_gun:this.no_gun,
        // installed_date:this.installed_date,
        // maker:this.maker,
        // model:this.model,
        // special_use:this.isPublic,
        // manufacturer_sn:this.manufacturer_sn,
        // manufacturer_name:this.manufacturer_name,
        // equipment_model:this.equipment_model,
        // equipment_power:this.equipment_power,
        // longitude:this.longitude,
        // latitude:this.latitude,
        // equipment_sn:this.equipment_sn,
        // national_standard:this.national_standard,
        // connector_name:this.connector_name,
        // connector_type:this.connectorType,
        // rated_voltage_upper_limit:this.rated_voltage_upper_limit,
        // rated_voltage_lower_limit:this.rated_voltage_lower_limit,
        // rated_current:this.rated_current,
        // park_no:this.park_no,
        // rated_power:this.rated_power,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
        transformRequest: [
          function (data) {
            //在请求之前对data传参进行格式转换
            data = Qs.stringify(data);
            return data;
          },
        ],
        params: {},
        data: {
          uid: localStorage.getItem("uid"),
          token: localStorage.getItem("token"),
          action: "editCharger",
          charger_id: this.charger_id,
          charger_name: this.charger_name,
          type: this.type,
          charge_type: this.charge_type,
          serial_no: this.serial_no,
          no_gun: this.no_gun,
          installed_date: parseDateFilter(this.installed_date, "yyyy-MM-dd"),
          maker: this.maker,
          model: this.model,
          special_use: this.isPublic,
          equipment_application:this.equipment_application,

          manufacturer_sn: this.manufacturer_sn,
          manufacturer_name: this.manufacturer_name,
          equipment_model: this.equipment_model,
          equipment_power: Number(this.equipment_power).toFixed(1),
          longitude: this.longitude,
          latitude: this.latitude,
          // equipment_sn: this.equipment_sn,
          national_standard: this.national_standard,

          connector_name: this.connector_name,
          connector_type: this.connectorType,
          rated_voltage_upper_limit: this.rated_voltage_upper_limit,
          rated_voltage_lower_limit: this.rated_voltage_lower_limit,
          rated_current: this.rated_current,
          park_no: this.park_no,
          rated_power: this.rated_power,
        },
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.pliaTemplateList=[]
            this.newChargingPileDialog = false;
            this.$message.success("编辑成功");
            this.getDataList(this.provincesName, this.cityName, this.stationId);
            this.editNumber = 0;
            this.stationNameIdC = "";
            this.charger_id = "";
            this.charger_name = "";
            this.type = "";
            this.charge_type = "";
            this.serial_no = "";
            this.no_gun = "";
            this.installed_date = "";
            this.maker = "";
            this.model = "";
            this.provincesNameC = "";
            this.cityNameC = "";
            this.stationNameC = "";
            this.isPublic = "0";

            this.manufacturer_sn = "";
            this.manufacturer_name = "";
            this.equipment_model = "";
            this.equipment_power = "";
            this.national_standard = "";
            this.longitude = "";
            this.latitude = "";
            // this.equipment_sn = "";

            this.connector_name = [];
            this.connectorType = [];
            this.rated_voltage_upper_limit = [];
            this.rated_voltage_lower_limit = [];
            this.rated_current = [];
            this.park_no = [];
            this.rated_power = [];
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    editCharing(row) {
      this.getcharingPie(row.maker)
      this.chargingPileTitle = "编辑充电桩";
      this.newChargingPileDialog = true;
      this.getCharProvinces();
      this.disabledD = 1;
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getChargerDetail",
        charger_id: row.charger_id,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.provincesNameC = su.data.list.province;
            this.cityNameC = su.data.list.city;
            this.editNumber = 1;
            this.cityDChange(this.cityNameC);
            // this.provincesDChange(this.provincesNameC);
            this.stationNameC = su.data.list.station_id;
            this.charge_type = su.data.list.charge_type;
            this.charger_id = su.data.list.charger_id;
            this.charger_name = su.data.list.charger_name;
            this.installed_date = su.data.list.installed_date;
            this.maker = su.data.list.maker;
            this.model = su.data.list.model;
            this.no_gun = su.data.list.no_gun;
            this.serial_no = su.data.list.serial_no;
            this.type = su.data.list.type;
            this.isPublic = su.data.list.special_use;
            this.equipment_application=su.data.list.equipment_application

            this.manufacturer_sn = su.data.list.manufacturer_sn;
            // this.equipment_sn = su.data.list.equipment_sn;
            this.manufacturer_name = su.data.list.manufacturer_name;
            this.equipment_model = su.data.list.equipment_model;
            this.equipment_power = su.data.list.equipment_power;
            this.longitude = su.data.list.equipment_longitude;
            this.latitude = su.data.list.equipment_latitude;
            this.national_standard = su.data.list.national_standard;

            this.connectorType[0] = su.data.list.gun[0].connector_type;
            this.connector_name[0] = su.data.list.gun[0].connector_name;
            this.rated_voltage_upper_limit[0] =
              su.data.list.gun[0].rated_voltage_upper_limit;
            this.rated_voltage_lower_limit[0] =
              su.data.list.gun[0].rated_voltage_lower_limit;
            this.rated_current[0] = su.data.list.gun[0].rated_current;
            this.park_no[0] = su.data.list.gun[0].park_no;
            this.rated_power[0] = su.data.list.gun[0].rated_power;

            this.connectorType[1] = su.data.list.gun[1].connector_type;
            this.connector_name[1] = su.data.list.gun[1].connector_name;
            this.rated_voltage_upper_limit[1] =
              su.data.list.gun[1].rated_voltage_upper_limit;
            this.rated_voltage_lower_limit[1] =
              su.data.list.gun[1].rated_voltage_lower_limit;
            this.rated_current[1] = su.data.list.gun[1].rated_current;
            this.park_no[1] = su.data.list.gun[1].park_no;
            this.rated_power[1] = su.data.list.gun[1].rated_power;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    deleteCharing(row) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "deleteCharger",
        charger_id: row.charger_id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "",
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/DeviceManage/index",
            data: params,
            transformRequest: [
              (data) => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              },
            ],
          })
            .then((su) => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getDataList(
                  this.provincesName,
                  this.cityName,
                  this.stationId
                );
              } else if (su.data.code == 300) {
                localStorage.clear();
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900) {
              } else {
                this.$message.error(su.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    allCharing() {
      this.getDataList(this.provincesName, this.cityName, this.stationId);
    },
    prohibitClick() {
      this.totalNum = 0;
      this.tableData = [];
      this.yemiandata = [];
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getDisabledChargerList",
        station_id: this.stationId,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.tableData1 = su.data.list;
            this.totalNum = this.tableData1.length;
            if (this.totalNum > 10) {
              this.yemiandata = this.tableData1.slice(
                this.startnum * this.datanum,
                this.endnum * this.datanum
              );
            } else {
              this.yemiandata = this.tableData1;
            }
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    disableCharger(row) {
      this.prohibitDialog = true;
      this.prohibitReason = "";
      this.prohibitChargerId = row.charger_id;
    },
    prohibitCancelClick() {
      this.prohibitDialog = false;
      this.prohibitReason = "";
      this.prohibitChargerId = "";
    },
    prohibitConfirmClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "disableCharger",
        charger_id: this.prohibitChargerId,
        disabled_reason: this.prohibitReason,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.$message.success(su.data.message);
            this.prohibitDialog = false;
            this.prohibitReason = "";
            this.prohibitChargerId = "";
            this.getDataList(this.provincesName, this.cityName, this.stationId);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    enableClick(row) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "enableCharger",
        charger_id: row.charger_id,
      };
      this.$confirm("确定启用", "启用", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "",
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/DeviceManage/index",
            data: params,
            transformRequest: [
              (data) => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              },
            ],
          })
            .then((su) => {
              if (su.data.code == 1) {
                this.$message.success(su.data.message);
                this.getDataList(
                  this.provincesName,
                  this.cityName,
                  this.stationId
                );
              } else if (su.data.code == 300) {
                localStorage.clear();
                this.$router.push("/login");
                this.$message.error(su.data.message);
              } else if (su.data.code == 900) {
              } else {
                this.$message.error(su.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
    rateClick(row) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getChargerRateTemplate",
        charger_id: row.charger_id,
      };
      this.$api({
        method: "post",
        url: "/api.php/DeviceManage/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.royaltyRateDialog = true;
            this.rateList = su.data.list;
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.error(su.data.message);
          } else if (su.data.code == 900) {
          } else {
            this.$message.error(su.data.message);
          }
        })
        .catch((err) => {});
    },
  },
  props: {
    provincesName: {
      type: String,
      required: true,
    },
    cityName: {
      type: String,
      required: true,
    },
    stationId: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.charing-pile {
  .charing-pile-top {
    .btn {
      border: none;
      color: #ffffff;
    }
    .btn-left {
      float: left;
    }
    .btn-right {
      float: right;
    }
    .input-left {
      width: 20%;
      margin-left: 10px;
    }
    .btn-all {
      margin-left: 1%;
      background-color: #0177bd;
    }
    .btn-all:active {
      background-color: #409eff;
    }
    .btn-disabled {
      background-color: #f00001;
    }
    .btn-disabled:active {
      background-color: #f15500;
    }
    .btn-pile {
      margin-right: 1%;
      background-color: #f15500;
    }
    .btn-pile.active {
      background-color: #a5a5a5;
    }
  }
  .charing-pile-table {
    margin-top: 24px;
    width: 98%;
    margin-left: 1%;
    .btn {
      width: 54px;
      height: 26px;
      color: #ffffff;
      border: none;
      padding: 0;
      text-align: center;
      font-size: 12px;
    }
    .edit {
      background-color: #0171bb;
    }
    .delete {
      background-color: #00b270;
    }
    .rate {
      background-color: #f15500;
    }
    .disabled {
      background-color: #01a2b4;
    }
    .el-button + .el-button {
      margin-left: 5px;
    }
    .edit.active {
      background-color: #a5a5a5;
    }
    .delete.active {
      background-color: #a5a5a5;
    }
    .rate.active {
      background-color: #a5a5a5;
    }
    .disabled.active {
      background-color: #a5a5a5;
    }
    .quick-charge {
      color: #ef0003;
    }
    .slow-charging {
      color: #458bc6;
    }
    .communication {
      color: #458bc6;
    }
    .direct {
      color: #00b270;
    }
    .enable {
      color: #01945e;
    }
    .enable-prohibit {
      color: #ef0003;
    }
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
    margin-right: 18px;
  }
  .new-charging-pile-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .charging-pile-content {
      .content-left {
        .details {
          margin-bottom: 16px;
          .details-title {
            display: inline-block;
            width: 30%;
            text-align: right;
            .star {
              color: #ee0002;
            }
          }
          .details-r {
            display: inline-block;
            width: 65%;
            .el-select,
            .el-date-picker {
              width: 32%;
            }
          }
          .details-r2 {
            display: inline-block;
            width: 65%;
            .el-select {
              width: 100%;
            }
          }
        }
        .fg-line {
          width: 100%;
          height: 1px;
          background-color: #eaeaea;
          margin-bottom: 16px;
        }
      }
      .content-right {
        .details {
          margin-bottom: 16px;
          .details-title {
            display: inline-block;
            width: 30%;
            text-align: right;
            .star {
              color: #ee0002;
            }
          }
          .details-r {
            display: inline-block;
            width: 65%;
            .el-select,
            .el-date-picker {
              width: 32%;
            }
          }
          .details-r2 {
            display: inline-block;
            width: 65%;
            .el-select {
              width: 100%;
            }
          }
        }
        .fg-line {
          width: 100%;
          height: 1px;
          background-color: #eaeaea;
          margin-bottom: 16px;
        }
      }
    }
    .button {
      margin-top: 20px;
      .button-cancel {
        width: 26%;
        height: 50px;
        background-color: #0071bd;
        border: none;
        color: #ffffff;
      }
      .button-confirm {
        width: 26%;
        height: 50px;
        background-color: #02b36f;
        border: none;
        color: #ffffff;
      }
    }
  }
  .prohibit-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .prohibit-reason {
      width: 90%;
      // margin-left: 4%;
      .text {
        display: inline-block;
        width: 26%;
        text-align: right;
        vertical-align: top;
        .star {
          color: #ee0002;
          margin-right: 6px;
        }
      }
      .reason-box {
        display: inline-block;
        width: 70%;
      }
    }
    .pro-button {
      margin-top: 40px;
      .pro-cancel {
        width: 26%;
        height: 50px;
        background-color: #0071bd;
        border: none;
        color: #ffffff;
      }
      .pro-confirm {
        width: 26%;
        height: 50px;
        background-color: #02b36f;
        border: none;
        color: #ffffff;
      }
    }
  }
  .royalty-rate-dialog {
    position: relative;
    overflow-x: hidden;
    .title {
      font-size: 18px;
      position: absolute;
      left: 16px;
      top: 16px;
      color: #0171bd;
    }
    .line {
      width: calc(100% + 40px);
      margin-left: -20px;
      margin-right: -20px;
      height: 1px;
      margin-top: 14px;
      background-color: #eaeaea;
      margin-bottom: 30px;
    }
    .royalty-rate-content {
      .rate-top {
        .rate-t-l {
          display: inline-block;
          width: 60%;
          text-align: left;
          margin-left: -29px;
        }
        .rate-t-r {
          display: inline-block;
          width: 36%;
          text-align: left;
        }
      }
      .rate-center {
        margin-top: 30px;
        .rate-c-title {
          width: 100%;
          height: 36px;
          vertical-align: top;
          text-align: left;
          border-bottom: 1px solid #eaeaea;
          span {
            color: #555555;
          }
        }
        .rate-c-content {
          width: 100%;
          height: 60px;
          line-height: 60px;
          border-bottom: 1px solid #eaeaea;
          .rate-details {
            width: 30%;
            display: inline-block;
            margin-right: 3%;
            .rate-details-l {
              float: left;
            }
            .rate-details-r {
              float: right;
            }
          }
        }
      }
      .rate-bottom {
        margin-top: 30px;
        .rate-b-title {
          width: 100%;
          height: 36px;
          vertical-align: top;
          text-align: left;
          border-bottom: 1px solid #eaeaea;
          span {
            color: #555555;
          }
        }
        .dialog-bottom {
          margin-top: 30px;
          .dialog-bottom-title {
            font-size: 16px;
            color: #555555;
            text-align: left;
            span {
              font-size: 12px;
              color: #ec0100;
            }
          }
          .bottom-line {
            width: 100%;
            height: 1px;
            background-color: #eeeeee;
            margin-top: 22px;
          }
          .dialog-bottom-select {
            width: 100%;
            // margin-top: 20px;
            height: 50px;
            line-height: 50px;
            float: left;
            border-bottom: 1px solid #eeeeee;
            span {
              float: left;
              margin-bottom: 20px;
              width: 20%;
              height: 38px;
              line-height: 38px;
              border: 1px solid #e4e7ed;
              border-radius: 6px;
              margin-left: 4%;
              margin-top: 5px;
              text-align: left;
              padding-left: 6px;
            }
            .box {
              display: inline-block;
            }
            .time1 {
              display: inline-block;
              width: 7%;
              border: none;
            }
            .el-date-editor {
              width: 29%;
            }
            .line2 {
              width: 100%;
              height: 1px;
              background-color: #eeeeee;
              margin-top: 16px;
            }
          }
          .add-delete {
            margin-top: 20px;
            display: flex;
            span {
              display: inline-block;
              width: 50px;
              height: 40px;
              background-color: #e7e7e7;
              color: #777777;
              line-height: 40px;
              text-align: center;
              font-size: 26px;
              margin-right: 10px;
              border-radius: 6px;
              cursor: pointer;
            }
          }
          .cencel-confirm {
            margin-top: 20px;
            .el-button {
              width: 25%;
              color: #ffffff;
              border: none;
              height: 50px;
            }
            .cencel {
              background-color: #0071bd;
            }
            .confirm {
              background-color: #02b36f;
            }
          }
        }
        .rate-b-content {
          width: 100%;
          line-height: 60px;
          .content-l {
            width: 45%;
            float: left;
            height: 60px;
            border-bottom: 1px solid #eaeaea;
            // margin-right: 5%;
            div {
              float: left;
              width: 23%;
              text-align: left;
            }
            .content-l-l {
            }
            .content-l-c {
              text-align: center;
            }
            .content-l-r {
              text-align: right;
            }
          }
          .content-l:nth-child(2n) {
            float: right;
          }
          .content-r {
            width: 45%;
            float: right;
            height: 60px;
            border-bottom: 1px solid #eaeaea;
            div {
              float: left;
              width: 23%;
              text-align: left;
            }
            .content-l-l {
            }
            .content-l-c {
              text-align: center;
            }
            .content-l-r {
              text-align: right;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.charing-pile .el-table--enable-row-hover .el-table__body tr:hover > td .edit {
  background-color: #409eff;
}
.charing-pile
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td
  .quick-charge {
  color: #ffffff;
}
.charing-pile
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td
  .slow-charging {
  color: #ffffff;
}
.charing-pile
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td
  .communication {
  color: #ffffff;
}
.charing-pile
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td
  .direct {
  color: #ffffff;
}
.charing-pile
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td
  .enable {
  color: #ffffff;
}
.charing-pile
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td
  .enable-prohibit {
  color: #ffffff;
}

// .charing-pile .el-input.is-disabled .el-input__inner {
//         background-color: #ffffff;
//         color: #606266;
//     }
</style>


// WEBPACK FOOTER //
// src/components/stationManagement/chargingPile.vue